import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Field = ({ label, ...props }) => (
  <label className="block">
    <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-500">{label}</span>
    <input
      {...props}
      className="w-full bg-transparent border-b border-white/20 py-3 text-lg text-white placeholder-zinc-600 focus:border-red-600 focus:outline-none transition-colors"
    />
  </label>
);

export const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [loading, setLoading] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Compila nome, email e messaggio.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast.success("Richiesta inviata! Ti risponderemo al più presto.");
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (err) {
      toast.error("Invio non riuscito. Riprova o scrivici via email.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contatti" data-testid="contact" className="border-t border-white/10">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-24 md:py-32 grid grid-cols-1 lg:grid-cols-2 gap-16">
        <Reveal>
          <div className="flex items-center gap-3 mb-6">
            <span className="w-8 h-px bg-red-600" />
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-red-600">Contatti</span>
          </div>
          <h2 className="font-display font-black uppercase text-4xl md:text-6xl tracking-tighter leading-none mb-10">
            Parliamo di<br />precisione
          </h2>
          <div className="space-y-6 font-mono text-sm text-zinc-400">
            <div>
              <div className="text-zinc-600 uppercase text-[11px] tracking-widest mb-1">Sede</div>
              <div className="text-zinc-200">Via John Fitzgerald Kennedy 5-7-9</div>
              <div>Zona Industriale Torrazzi, 41122 Modena (MO)</div>
            </div>
            <div>
              <div className="text-zinc-600 uppercase text-[11px] tracking-widest mb-1">Telefono</div>
              <a href="tel:+39059260288" data-testid="contact-phone" className="text-zinc-200 hover:text-red-600 transition-colors">+39 059 260288</a>
            </div>
            <div>
              <div className="text-zinc-600 uppercase text-[11px] tracking-widest mb-1">Email</div>
              <a href="mailto:cobi@cobimeccanica.it" data-testid="contact-email" className="text-zinc-200 hover:text-red-600 transition-colors">cobi@cobimeccanica.it</a>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <form onSubmit={submit} data-testid="contact-form" className="space-y-8">
            <Field label="Nome e Azienda" data-testid="input-name" value={form.name} onChange={update("name")} placeholder="Mario Rossi — Azienda S.r.l." />
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
              <Field label="Email" type="email" data-testid="input-email" value={form.email} onChange={update("email")} placeholder="nome@azienda.it" />
              <Field label="Telefono (opzionale)" data-testid="input-phone" value={form.phone} onChange={update("phone")} placeholder="+39 ..." />
            </div>
            <label className="block">
              <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-500">Il tuo progetto</span>
              <textarea
                data-testid="input-message"
                value={form.message}
                onChange={update("message")}
                rows={4}
                placeholder="Descrivi il componente o l'attrezzatura di cui hai bisogno..."
                className="w-full bg-transparent border-b border-white/20 py-3 text-lg text-white placeholder-zinc-600 focus:border-red-600 focus:outline-none transition-colors resize-none"
              />
            </label>
            <button
              type="submit"
              data-testid="submit-contact"
              disabled={loading}
              className="group flex items-center gap-3 bg-red-600 text-white px-8 py-4 font-mono uppercase text-sm tracking-widest hover:bg-white hover:text-black transition-colors disabled:opacity-60"
            >
              {loading ? <Loader2 className="animate-spin" size={18} /> : <>Invia richiesta <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" /></>}
            </button>
          </form>
        </Reveal>
      </div>
    </section>
  );
};
